import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import "../../styles/vendor/react-checkbox-tree.css";
import { Link } from "react-router-dom";
import FullCalendar from "./fields/FullCalendar";
import moment from "moment/moment";
import { baseValue } from "../../libs/utils";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      events: []
    };

    this._handleDateSelection = this._handleDateSelection.bind(this);
    this._handleDateEdit = this._handleDateEdit.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFieldUpdate = this._handleFieldUpdate.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    cateringOption: PropTypes.object,
    isCreating: PropTypes.bool,
    periods: PropTypes.array,
    "periods.map": PropTypes.func,
    setFieldValue: PropTypes.func,
    cateringPeriods: PropTypes.array,
    event: PropTypes.object
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { cateringOption } = nextProps;
    const currentProps = this.props;

    if (currentProps.cateringOption !== cateringOption) {
      currentProps.setFieldValue("id", baseValue(cateringOption.id));
      currentProps.setFieldValue("name", baseValue(cateringOption.name));
      currentProps.setFieldValue(
        "cost",
        baseValue(parseInt(cateringOption.cost, 10) / 100)
      );
      currentProps.setFieldValue(
        "costNoShow",
        baseValue(parseInt(cateringOption.costNoShow, 10) / 100)
      );
    }

    const { cateringPeriods } = nextProps;
    if (currentProps.cateringPeriods !== cateringPeriods) {
      if (cateringPeriods) {
        let events = [];

        for (let i = 0; i < cateringPeriods.length; i++) {
          events.push({
            myId: i,
            start: moment(cateringPeriods[i].startsAt),
            end: moment(cateringPeriods[i].endsAt),
            className: "m-fc-event--accent m-fc-event--solid-accent",
            allDay: true,
            relatedDays: cateringPeriods[i].relatedDays,
            relatedPeriodId: cateringPeriods[i].relatedPeriodId
          });
        }

        currentProps.setFieldValue("periods", events);
        this.setState({ events });
      }
    }

    if (currentProps.isCreating && !nextProps.isCreating) {
      const venue = currentProps.values.venue;
      currentProps.resetForm();
      currentProps.setFieldValue("venue", venue);
    }
  }

  _handleDateSelection(startObj, endObj) {
    const newEvent = {
      myId: this.state.events.length,
      start: startObj,
      end: endObj.subtract(1, "day"),
      className: "m-fc-event--accent m-fc-event--solid-accent",
      relatedDays: undefined,
      relatedPeriodId: undefined
    };

    const events = [].concat(this.state.events).concat(newEvent);

    this.setState({ events });
    this.props.setFieldValue("periods", events);
  }

  _handleDateEdit(event) {
    const events = [].concat(this.state.events);

    events[event.myId].start = moment(event.start);
    events[event.myId].end = moment(event.end).subtract(1, "days");

    this.setState({ events });
    this.props.setFieldValue("periods", events);
  }

  _handleDelete(e, eventId) {
    let events = this.state.events.filter(event => event.myId !== eventId);
    events.forEach((event, index) => (event.myId = index));

    this.setState({ events });
    this.props.setFieldValue("periods", events);
  }

  _handleFieldUpdate(e, field, eventId) {
    const events = [].concat(this.state.events);
    events[eventId][field] = e.target.value;

    this.setState({ events });
    this.props.setFieldValue("periods", events);
  }

  render() {
    const {
      event,
      periods,
      handleSubmit,
      isSubmitting,
      cateringOption
    } = this.props;
    const { events } = this.state;

    let validRange = undefined;
    if (event.startsAt) {
      validRange = {
        start: event.startsAt.split(" ")[0],
        end: event.endsAt.split(" ")[0]
      };
    }

    const calEvents = [].concat(events).map(event => {
      const newEvent = { ...event };
      newEvent.end = moment(newEvent.end).add(1, "days");
      return newEvent;
    });

    return (
      <form className="m-login__form m-form" onSubmit={handleSubmit}>
        <div className="m-portlet__body">
          <div className="row">
            <div className="col-xl-6">
              <input type="hidden" name="id" />
              <BasicInput
                {...this.props}
                name="name"
                type="text"
                label="Name"
              />
              <BasicInput
                {...this.props}
                name="cost"
                type="text"
                label="Cost"
              />
              <BasicInput
                {...this.props}
                name="costNoShow"
                type="text"
                label="Cost No Show"
              />

              {events.length > 0 && (
                <div className="form-group m-form__group">
                  <label>Overview</label>
                  <table className="table m-table m-table--head-separator-primary">
                    <thead>
                      <tr>
                        <th>Start</th>
                        <th>Stop</th>
                        <th>Related Period</th>
                        <th>Related Days</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {events.map(event => {
                        const start = moment(event.start);
                        const end = moment(event.end);

                        return (
                          <tr key={event.myId}>
                            <td>{start.format("DD/MM/YY")}</td>
                            <td>{end.format("DD/MM/YY")}</td>
                            <td>
                              <select
                                name=""
                                id=""
                                className="form-control m-input"
                                onChange={e =>
                                  this._handleFieldUpdate(
                                    e,
                                    "relatedPeriodId",
                                    event.myId
                                  )
                                }
                                value={event.relatedPeriodId}
                              >
                                <option value="">No related period</option>
                                {periods.map(period => (
                                  <option value={period.id} key={period.id}>
                                    {period.name}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control m-input"
                                onChange={e =>
                                  this._handleFieldUpdate(
                                    e,
                                    "relatedDays",
                                    event.myId
                                  )
                                }
                                value={event.relatedDays}
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-outline-danger m-btn m-btn--icon m-btn--icon-only"
                                onClick={e => this._handleDelete(e, event.myId)}
                              >
                                <i className="la la-trash" />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="col-xl-6">
              <div className="form-group m-form__group">
                <label>Availability</label>
                <FullCalendar
                  validRange={validRange}
                  selectable
                  editable
                  handleSelect={this._handleDateSelection}
                  handleEdit={this._handleDateEdit}
                  events={calEvents}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              <button
                className={
                  "btn m-btn btn-primary" +
                  (isSubmitting
                    ? " m-btn--custom m-loader m-loader--light m-loader--left"
                    : "")
                }
                disabled={isSubmitting}
              >
                {cateringOption ? "Update" : "Create"}
              </button>
              <span className="m--margin-left-10">
                or{" "}
                <Link
                  to={`/admin/events/${this.props.event.id}/catering`}
                  className="m-link m--font-bold"
                >
                  Cancel
                </Link>
              </span>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const CateringOptionsForm = withFormik({
  mapPropsToValues: props => {
    const cateringOption = baseValue(props.cateringOption, {});

    return {
      name: baseValue(cateringOption.name),
      id: baseValue(cateringOption.id),
      cost: baseValue(parseInt(cateringOption.cost, 10) / 100),
      costNoShow: baseValue(parseInt(cateringOption.costNoShow, 10) / 100),
      periods: []
    };
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    if (!values.cost || values.cost === "") {
      errors.cost = "required";
    }

    if (!values.costNoShow || values.costNoShow === "") {
      errors.costNoShow = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default CateringOptionsForm;
